import React, { memo } from 'react';
import { Brain, Check, AlertTriangle, Clock, Target, Zap, BookOpen, Users, ShieldCheck, Shield, X, GraduationCap, Layers, TrendingUp, UserCheck, Download, Printer, Eye, BarChart3 } from 'lucide-react';
import { CTAButton } from '../components/CTAButton';
import { TestimonialCard } from '../components/TestimonialCard';
import { BonusCard } from '../components/BonusCard';
import { ImageCarousel } from '../components/ImageCarousel';
const CHECKOUT_URL = 'https://checkout.impulsodigitalx.shop/cart/45711849652385:1';
const MAIN_IMAGE = 'https://cdn.magicpatterns.com/uploads/xeeyEkbrnyJDmAbLpp3jSa/MOCKUP_gimnasia_cerebral_infantil.png';
const BONO1_IMAGE = 'https://cdn.magicpatterns.com/uploads/4JHzAbAuXPjV7eq6DSgZ8w/ChatGPT_Image_9_feb_2026,_11_20_17_p.m..png';
const BONO2_IMAGE = 'https://cdn.magicpatterns.com/uploads/k387Yvpic8ZQpfRjn2HDHw/ChatGPT_Image_9_feb_2026,_11_29_27_p.m..png';
const BONO3_IMAGE = 'https://cdn.magicpatterns.com/uploads/473hp7nbK2DjVAUwa3BJQz/ChatGPT_Image_9_feb_2026,_11_41_00_p.m..png';
const CAROUSEL_IMAGES = [{
  src: 'https://cdn.magicpatterns.com/uploads/tSxSeVETp6tnBCD8ELz2ps/Modulo-1.png',
  alt: 'Módulo 1 - Activación de la Atención'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/iCT6AjLCzddMP3d58aXg1X/Ejercicio-Completar-Patrones-Simples.png',
  alt: 'Ejercicio - Completar Patrones Simples'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/mwaTkXY65dztrmSg9C8Njk/Ejercicio-Completar-Patrones-Avanzados.png',
  alt: 'Ejercicio - Completar Patrones Avanzados'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/r8kkdeSeGZjKHzgjVs5sNM/Ejercicio-Ordenar-Secuencia-de-Rutina-Diaria.png',
  alt: 'Ejercicio - Ordenar Secuencia de Rutina Diaria'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/oSN28Hij9m3o4sNE8qT6Qv/rakp4z7mx95dhy9.png',
  alt: 'Ejercicio - Encontrar las 5 Diferencias'
}];
export function SalesPage() {
  return <div className="min-h-screen bg-brand-cream font-sans text-brand-brown" data-id="element-65">
      {/* Top Bar */}
      <div className="bg-brand-coral text-white text-center py-3 text-sm font-black tracking-wide uppercase" data-id="element-66">
        ⚠️ OFERTA DE LANZAMIENTO ⚠️
      </div>

      {/* ===== HERO: Problem + Product Intro ===== */}
      <header className="py-12 px-4 md:py-20 bg-brand-cream" data-id="element-67">
        <div className="max-w-4xl mx-auto text-center" data-id="element-68">
          <h1 className="text-4xl md:text-6xl lg:text-7xl font-black text-brand-brown mb-4 leading-tight" data-id="element-69">
            🧠 GIMNASIA CEREBRAL INFANTIL
          </h1>

          <p className="text-xl md:text-2xl font-bold text-brand-brown-light mb-8 max-w-3xl mx-auto" data-id="element-70">
            Tu hijo no necesita más pantallas. Necesita entrenamiento mental.
          </p>

          <p className="text-lg md:text-xl text-brand-brown-light font-medium mb-8 max-w-3xl mx-auto leading-relaxed" data-id="element-71">
            Sistema estructurado para mejorar atención, memoria y concentración
            en solo 10 minutos diarios.
          </p>

          <a href={CHECKOUT_URL} target="_blank" rel="noopener noreferrer" className="block relative w-full max-w-xl mx-auto mb-10 group" data-id="element-72">
            <img src={MAIN_IMAGE} alt="Mega Pack Gimnasia Cerebral Infantil" className="w-full h-auto rounded-2xl shadow-xl transition-transform duration-300 group-hover:scale-[1.02]" data-id="element-73" />
          </a>

          <div className="max-w-2xl mx-auto mb-10" data-id="element-74">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 text-left" data-id="element-75">
              {['Actividades listas para imprimir', 'Método progresivo paso a paso', 'Resultados observables en casa o en el aula', 'Sin pantallas', 'Aplicable desde el primer día'].map((item, i) => <div key={i} className="flex items-start gap-2 bg-white p-3 rounded-lg border border-brand-border shadow-sm" data-id="element-76">
                  <Check className="w-5 h-5 text-brand-sage flex-shrink-0 mt-0.5" data-id="element-77" />
                  <span className="font-bold text-brand-brown text-sm" data-id="element-78">
                    {item}
                  </span>
                </div>)}
            </div>
          </div>

          <CTAButton subtext="Descarga Inmediata · Acceso de por vida" data-id="element-79">
            👉 QUIERO MEJORAR LA CONCENTRACIÓN AHORA
          </CTAButton>
        </div>
      </header>

      {/* ===== MIRÁ LO QUE RECIBÍS (Carousel) ===== */}
      <section className="py-16 px-4 bg-white" data-id="element-80">
        <div className="max-w-4xl mx-auto" data-id="element-81">
          <div className="text-center mb-4" data-id="element-82">
            <h2 className="text-3xl md:text-4xl font-black text-brand-brown mb-3" data-id="element-83">
              👀 MIRÁ EXACTAMENTE LO QUE RECIBÍS
            </h2>
            <p className="text-lg text-brand-brown-light mb-2" data-id="element-84">
              Esto no son ejercicios sueltos. Es un{' '}
              <strong className="text-brand-brown" data-id="element-85">
                sistema completo de entrenamiento cognitivo infantil.
              </strong>
            </p>
          </div>

          <div className="max-w-2xl mx-auto mb-8" data-id="element-86">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3" data-id="element-87">
              {['Ejercicios reales de atención progresiva', 'Actividades de memoria visual estructurada', 'Retos cognitivos por nivel de dificultad', 'Material listo para imprimir y aplicar'].map((item, i) => <div key={i} className="flex items-start gap-2 p-3" data-id="element-88">
                  <Check className="w-5 h-5 text-brand-sage flex-shrink-0 mt-0.5" data-id="element-89" />
                  <span className="font-medium text-brand-brown text-sm" data-id="element-90">
                    {item}
                  </span>
                </div>)}
            </div>
          </div>

          <div className="bg-brand-peach rounded-2xl p-6 mb-8 text-center" data-id="element-91">
            <p className="text-lg font-black text-brand-brown" data-id="element-92">
              Imprimís → aplicás → observás mejoras reales.
            </p>
          </div>

          <ImageCarousel images={CAROUSEL_IMAGES} data-id="element-93" />

          <div className="mt-10 max-w-3xl mx-auto" data-id="element-94">
            <CTAButton subtext="Descarga inmediata" data-id="element-95">
              🧠 ¡QUIERO ESTE MATERIAL!
            </CTAButton>
          </div>
        </div>
      </section>

      {/* ===== CÓMO FUNCIONA EN LA VIDA REAL ===== */}
      <section className="py-16 px-4 bg-brand-peach" data-id="element-96">
        <div className="max-w-4xl mx-auto" data-id="element-97">
          <div className="text-center mb-12" data-id="element-98">
            <h2 className="text-2xl md:text-4xl font-black text-brand-brown" data-id="element-99">
              🧩 CÓMO FUNCIONA EN LA VIDA REAL
            </h2>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-5" data-id="element-100">
            {[{
            step: '1️⃣',
            title: 'Descargás',
            desc: 'El material inmediatamente después de comprar.',
            icon: Download,
            bg: 'bg-brand-sky-light',
            color: 'text-brand-sky'
          }, {
            step: '2️⃣',
            title: 'Imprimís',
            desc: 'Las actividades que necesitás.',
            icon: Printer,
            bg: 'bg-brand-peach-dark',
            color: 'text-brand-coral'
          }, {
            step: '3️⃣',
            title: 'Entrena',
            desc: 'El niño solo 10–15 minutos por día.',
            icon: Brain,
            bg: 'bg-brand-sage-light',
            color: 'text-brand-sage'
          }, {
            step: '4️⃣',
            title: 'Observás',
            desc: 'Mejoras progresivas en concentración y aprendizaje.',
            icon: Eye,
            bg: 'bg-brand-gold-light',
            color: 'text-brand-gold'
          }].map((item, i) => <div key={i} className="bg-white p-5 rounded-2xl shadow-md text-center border border-brand-border" data-id="element-101">
                <div className={`${item.bg} w-12 h-12 rounded-xl flex items-center justify-center mx-auto mb-3`} data-id="element-102">
                  <item.icon className={`w-6 h-6 ${item.color}`} data-id="element-103" />
                </div>
                <span className="text-xl block mb-1" data-id="element-104">{item.step}</span>
                <h3 className="text-base font-black text-brand-brown mb-1" data-id="element-105">
                  {item.title}
                </h3>
                <p className="text-brand-brown-light text-sm" data-id="element-106">{item.desc}</p>
              </div>)}
          </div>

          <div className="mt-8 text-center" data-id="element-107">
            <p className="text-lg text-brand-brown-light font-medium" data-id="element-108">
              Sin pantallas. Sin preparación previa. Sin experiencia pedagógica.
            </p>
          </div>
        </div>
      </section>

      {/* ===== RESULTADOS QUE PODÉS OBSERVAR ===== */}
      <section className="py-16 px-4 bg-brand-sage-light" data-id="element-109">
        <div className="max-w-3xl mx-auto" data-id="element-110">
          <div className="text-center mb-10" data-id="element-111">
            <h2 className="text-2xl md:text-4xl font-black text-brand-brown" data-id="element-112">
              🎯 RESULTADOS QUE PODÉS OBSERVAR
            </h2>
          </div>

          <div className="space-y-3 mb-8" data-id="element-113">
            {['Mantiene la atención por más tiempo', 'Sigue instrucciones sin repetirlas', 'Termina tareas con menos frustración', 'Mejora su memoria visual', 'Se distrae menos al estudiar', 'Gana seguridad en el aprendizaje', 'Mejora su rendimiento escolar'].map((item, i) => <div key={i} className="flex items-center gap-3 bg-white p-4 rounded-lg border border-brand-sage/20 shadow-sm" data-id="element-114">
                <Check className="w-6 h-6 text-brand-sage flex-shrink-0" data-id="element-115" />
                <span className="font-bold text-brand-brown" data-id="element-116">{item}</span>
              </div>)}
          </div>

          <p className="text-center text-xl font-black text-brand-coral" data-id="element-117">
            Esto no es teoría. Son cambios visibles.
          </p>
        </div>
      </section>

      {/* ===== PRESENTAMOS EL SISTEMA COMPLETO ===== */}
      <section className="py-16 px-4 bg-white" data-id="element-118">
        <div className="max-w-4xl mx-auto" data-id="element-119">
          <div className="text-center mb-10" data-id="element-120">
            <h2 className="text-3xl md:text-5xl font-black text-brand-brown mb-4 leading-tight" data-id="element-121">
              🚀 PRESENTAMOS EL SISTEMA COMPLETO
            </h2>
            <p className="text-lg text-brand-brown-light max-w-3xl mx-auto" data-id="element-122">
              El Mega Pack Gimnasia Cerebral Infantil es un programa progresivo
              diseñado para fortalecer habilidades cognitivas clave:
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 mb-10" data-id="element-123">
            {['Atención sostenida', 'Memoria de trabajo', 'Concentración', 'Razonamiento lógico', 'Coordinación visual', 'Procesamiento cognitivo'].map((item, i) => <div key={i} className="flex items-center gap-3 bg-brand-cream p-4 rounded-lg border border-brand-border" data-id="element-124">
                <div className="w-2 h-2 rounded-full bg-brand-coral flex-shrink-0" data-id="element-125" />
                <span className="font-bold text-brand-brown" data-id="element-126">{item}</span>
              </div>)}
          </div>

          <p className="text-center text-xl font-black text-brand-coral" data-id="element-127">
            No es entretenimiento. Es entrenamiento mental estructurado.
          </p>
        </div>
      </section>

      {/* ===== TODO LO QUE RECIBÍS ===== */}
      <section className="py-16 px-4 bg-brand-cream" data-id="element-128">
        <div className="max-w-4xl mx-auto" data-id="element-129">
          <h2 className="text-3xl md:text-5xl font-black text-center text-brand-brown mb-12" data-id="element-130">
            📦 TODO LO QUE RECIBÍS
          </h2>

          <div className="space-y-4 mb-10" data-id="element-131">
            {[{
            title: 'Módulo 1',
            desc: 'Atención y concentración',
            icon: Target
          }, {
            title: 'Módulo 2',
            desc: 'Memoria y observación',
            icon: Brain
          }, {
            title: 'Módulo 3',
            desc: 'Coordinación visual',
            icon: Zap
          }, {
            title: 'Módulo 4',
            desc: 'Asociación y lógica',
            icon: BookOpen
          }, {
            title: 'Módulo 5',
            desc: 'Retos cognitivos integrales',
            icon: ShieldCheck
          }].map((module, i) => <div key={i} className="flex items-center gap-4 p-5 border border-brand-border rounded-xl bg-white" data-id="element-132">
                <div className="bg-brand-coral text-white p-3 rounded-lg flex-shrink-0" data-id="element-133">
                  <module.icon className="w-6 h-6" data-id="element-134" />
                </div>
                <div data-id="element-135">
                  <span className="font-bold text-brand-coral uppercase text-sm" data-id="element-136">
                    ✔ {module.title}
                  </span>
                  <p className="font-bold text-brand-brown text-lg" data-id="element-137">
                    {module.desc}
                  </p>
                </div>
              </div>)}
          </div>

          <div className="bg-brand-gold-light border border-brand-gold/30 rounded-xl p-6 mb-6" data-id="element-138">
            <h3 className="text-xl font-black text-brand-brown mb-4" data-id="element-139">
              Además incluye:
            </h3>
            <ul className="space-y-2" data-id="element-140">
              {['Workbook imprimible', 'Rutina semanal guiada', 'Registro de progreso cognitivo', 'Juegos cognitivos sin pantallas', 'Actividades listas para usar durante todo el año'].map((item, i) => <li key={i} className="flex items-center gap-2 text-brand-brown font-medium" data-id="element-141">
                  <Check className="w-5 h-5 text-brand-gold flex-shrink-0" data-id="element-142" />
                  {item}
                </li>)}
            </ul>
          </div>

          <p className="text-center text-lg font-bold text-brand-brown-light" data-id="element-143">
            Todo organizado paso a paso y listo para aplicar.
          </p>
        </div>
      </section>

      {/* ===== BASE PEDAGÓGICA ===== */}
      <section className="py-14 px-4 bg-white" data-id="element-144">
        <div className="max-w-3xl mx-auto text-center" data-id="element-145">
          <div className="inline-flex items-center gap-2 bg-brand-sky-light px-5 py-2 rounded-full mb-6" data-id="element-146">
            <GraduationCap className="w-5 h-5 text-brand-sky" data-id="element-147" />
            <span className="font-bold text-brand-sky text-sm uppercase tracking-wide" data-id="element-148">
              Base científica
            </span>
          </div>
          <h2 className="text-2xl md:text-4xl font-black text-brand-brown mb-6" data-id="element-149">
            🎓 DESARROLLADO CON BASE PEDAGÓGICA
          </h2>
          <p className="text-lg text-brand-brown-light leading-relaxed mb-8" data-id="element-150">
            El programa trabaja funciones ejecutivas del cerebro infantil:
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 max-w-xl mx-auto mb-8" data-id="element-151">
            {['Atención sostenida', 'Memoria de trabajo', 'Procesamiento cognitivo', 'Razonamiento lógico'].map((item, i) => <div key={i} className="flex items-center gap-2 bg-brand-sky-light p-3 rounded-lg border border-brand-sky/20" data-id="element-152">
                <Check className="w-5 h-5 text-brand-sky flex-shrink-0" data-id="element-153" />
                <span className="font-bold text-brand-brown text-sm" data-id="element-154">
                  {item}
                </span>
              </div>)}
          </div>

          <p className="text-base text-brand-brown-light leading-relaxed" data-id="element-155">
            Basado en principios de estimulación cognitiva infantil y
            neuroaprendizaje aplicados al desarrollo escolar.
          </p>
        </div>
      </section>

      {/* ===== ¿PARA QUIÉN ES? ===== */}
      <section className="py-16 px-4 bg-brand-peach" data-id="element-156">
        <div className="max-w-3xl mx-auto" data-id="element-157">
          <div className="text-center mb-10" data-id="element-158">
            <h2 className="text-2xl md:text-4xl font-black text-brand-brown" data-id="element-159">
              👨‍👩‍👧 ¿PARA QUIÉN ES ESTE PROGRAMA?
            </h2>
            <p className="text-lg text-brand-brown-light mt-3" data-id="element-160">
              Este material es ideal si:
            </p>
          </div>

          <div className="bg-white p-6 rounded-2xl border border-brand-border shadow-md mb-6" data-id="element-161">
            <ul className="space-y-3" data-id="element-162">
              {['Tu hijo se distrae fácilmente', 'Le cuesta terminar tareas', 'Querés reducir el uso de pantallas', 'Buscás mejorar su concentración y memoria', 'Querés fortalecer habilidades cognitivas desde casa', 'Sos docente y necesitás estructura en el aula'].map((item, i) => <li key={i} className="flex items-start gap-2 text-brand-brown font-medium" data-id="element-163">
                  <Check className="w-5 h-5 text-brand-sage flex-shrink-0 mt-0.5" data-id="element-164" />
                  {item}
                </li>)}
            </ul>
          </div>

          <div className="bg-brand-red-light p-5 rounded-xl border border-brand-red/10 text-center" data-id="element-165">
            <p className="text-brand-brown-light font-medium" data-id="element-166">
              <X className="w-5 h-5 text-brand-red inline mr-1 -mt-0.5" data-id="element-167" />
              No es para vos si buscás soluciones mágicas sin práctica.
            </p>
          </div>
        </div>
      </section>

      {/* ===== BONOS ===== */}
      <section className="py-16 px-4 bg-white" data-id="element-168">
        <div className="max-w-5xl mx-auto" data-id="element-169">
          <div className="text-center mb-4" data-id="element-170">
            <span className="bg-brand-coral text-white px-6 py-2 rounded-full font-black uppercase tracking-widest text-sm mb-4 inline-block" data-id="element-171">
              🔥 Solo por lanzamiento
            </span>
            <h2 className="text-3xl md:text-5xl font-black mb-4 mt-4 text-brand-brown" data-id="element-172">
              🎁 BONOS EXCLUSIVOS GRATIS POR LANZAMIENTO
            </h2>
            <p className="text-xl text-brand-brown-light" data-id="element-173">
              Hoy recibís sin costo adicional:
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-6" data-id="element-174">
            <BonusCard title="Rutina Diaria de Gimnasia Cerebral" description="Guía práctica para padres y docentes. Uso en casa y en el aula." value="$12.000 ARS" imageSrc={BONO1_IMAGE} data-id="element-175" />
            <BonusCard title="Juegos Cognitivos Sin Pantallas" description="Actividades prácticas para estimular la mente infantil." value="$14.000 ARS" imageSrc={BONO2_IMAGE} data-id="element-176" />
            <BonusCard title="Registro de Progreso Cognitivo" description="Seguimiento de atención, memoria y concentración." value="$15.000 ARS" imageSrc={BONO3_IMAGE} data-id="element-177" />
          </div>

          <p className="text-center text-xl font-black text-brand-coral mb-8" data-id="element-178">
            Valor total $41.000 ARS — HOY GRATIS.
          </p>

          <div className="max-w-3xl mx-auto" data-id="element-179">
            <CTAButton subtext="Incluye los 3 bonos GRATIS" data-id="element-180">
              🟢 QUIERO TODO AHORA
            </CTAButton>
          </div>
        </div>
      </section>

      {/* ===== TESTIMONIOS ===== */}
      <section className="py-16 px-4 bg-brand-cream" data-id="element-181">
        <div className="max-w-6xl mx-auto" data-id="element-182">
          <h2 className="text-3xl md:text-4xl font-black text-center text-brand-brown mb-12" data-id="element-183">
            ⭐ LO QUE DICEN QUIENES YA LO USAN
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8" data-id="element-184">
            <TestimonialCard name="Gabriela M." role="Docente" content="En solo dos semanas mis alumnos mantienen la atención por más tiempo. Las actividades son claras y fáciles de aplicar." data-id="element-185" />
            <TestimonialCard name="Martín R." role="Padre" content="Mi hijo mejoró su concentración y ahora pide hacer los ejercicios." data-id="element-186" />
            <TestimonialCard name="Patricia L." role="Docente" content="Nunca encontré un material tan bien organizado para trabajar la atención." data-id="element-187" />
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-4xl mx-auto" data-id="element-188">
            <TestimonialCard name="Soledad P." role="Docente de nivel inicial, Rosario" content="Lo mejor es que no necesitás preparar nada. Imprimís y listo. Mis nenes de sala de 5 lo disfrutan mucho." data-id="element-189" />
            <TestimonialCard name="Carolina D." role="Mamá de Valentina (5 años), Mendoza" content="Mi hija se frustraba con las tareas. Con estos ejercicios empezó a ganar confianza y se concentra mucho mejor." data-id="element-190" />
          </div>
        </div>
      </section>

      {/* ===== ¿FUNCIONA REALMENTE? ===== */}
      <section className="py-16 px-4 bg-white" data-id="element-191">
        <div className="max-w-3xl mx-auto text-center" data-id="element-192">
          <h2 className="text-3xl font-black text-brand-brown mb-6" data-id="element-193">
            ❓ ¿FUNCIONA REALMENTE?
          </h2>
          <p className="text-xl text-brand-brown-light mb-4" data-id="element-194">
            Sí. La atención y la memoria se entrenan con práctica estructurada.
          </p>
          <p className="text-xl font-black text-brand-coral" data-id="element-195">
            El cerebro infantil mejora cuando recibe estimulación cognitiva
            progresiva.
          </p>
        </div>
      </section>

      {/* ===== PRICING ===== */}
      <section id="comprar" className="py-20 px-4 bg-brand-peach text-center relative overflow-hidden" data-id="element-196">
        <div className="max-w-4xl mx-auto relative z-10" data-id="element-197">
          <h2 className="text-3xl md:text-5xl font-black mb-3 text-brand-brown" data-id="element-198">
            💰 VALOR DEL PROGRAMA
          </h2>

          <a href={CHECKOUT_URL} target="_blank" rel="noopener noreferrer" className="block max-w-xs mx-auto my-8" data-id="element-199">
            <img src={MAIN_IMAGE} alt="Mega Pack Gimnasia Cerebral Infantil" className="w-full h-auto rounded-2xl shadow-xl hover:scale-105 transition-transform" data-id="element-200" />
          </a>

          <div className="bg-white text-brand-brown p-8 md:p-10 rounded-2xl max-w-2xl mx-auto shadow-xl mb-12 border-2 border-brand-coral" data-id="element-201">
            <div className="text-center mb-8" data-id="element-202">
              <p className="text-brand-brown-light text-lg line-through mb-1" data-id="element-203">
                Valor real del programa completo: $49.990 ARS
              </p>
              <div className="flex items-center justify-center gap-2" data-id="element-204">
                <span className="text-brand-red font-black text-xl" data-id="element-205">
                  🔥 HOY SOLO
                </span>
              </div>
              <div className="text-5xl md:text-7xl font-black text-brand-coral leading-none mt-2" data-id="element-206">
                $19.990{' '}
                <span className="text-2xl text-brand-brown-light font-medium" data-id="element-207">
                  ARS
                </span>
              </div>
            </div>

            <div className="bg-brand-cream border border-brand-border rounded-xl p-4 mb-8" data-id="element-208">
              <p className="font-bold text-brand-brown text-sm" data-id="element-209">Incluye:</p>
              <ul className="mt-3 space-y-2" data-id="element-210">
                {['Acceso inmediato', 'Descarga digital', 'Pago único', 'Acceso de por vida', 'Todos los módulos', 'Todos los bonos incluidos', 'Actualizaciones futuras sin costo'].map((item, i) => <li key={i} className="flex items-center gap-2" data-id="element-211">
                    <Check className="w-4 h-4 text-brand-sage flex-shrink-0" data-id="element-212" />
                    <span className="font-medium text-brand-brown text-sm" data-id="element-213">
                      {item}
                    </span>
                  </li>)}
              </ul>
            </div>

            <CTAButton data-id="element-214">👉 DESCARGAR EL MEGA PACK AHORA</CTAButton>

            <p className="text-xs text-brand-brown-light/60 mt-4 text-center" data-id="element-215">
              Pago único. Acceso de por vida. Garantía de 7 días.
            </p>
          </div>
        </div>
      </section>

      {/* ===== GARANTÍA ===== */}
      <section className="py-16 px-4 bg-brand-cream" data-id="element-216">
        <div className="max-w-3xl mx-auto" data-id="element-217">
          <div className="bg-brand-sage-light border-2 border-brand-sage/30 rounded-2xl p-8 md:p-10 text-center" data-id="element-218">
            <Shield className="w-16 h-16 text-brand-sage mx-auto mb-4" data-id="element-219" />
            <h2 className="text-2xl md:text-3xl font-black text-brand-brown mb-4" data-id="element-220">
              🔒 GARANTÍA TOTAL 7 DÍAS
            </h2>
            <p className="text-lg text-brand-brown-light leading-relaxed mb-2" data-id="element-221">
              Probá el material sin riesgo.
            </p>
            <p className="text-lg text-brand-brown-light leading-relaxed" data-id="element-222">
              Si no te resulta útil, te devolvemos el{' '}
              <strong className="text-brand-brown" data-id="element-223">100% del dinero</strong>. Sin
              preguntas. Sin vueltas.
            </p>
          </div>
        </div>
      </section>

      {/* ===== ¿Y SI NO HACÉS NADA? ===== */}
      <section className="py-16 px-4 bg-brand-red-light" data-id="element-224">
        <div className="max-w-3xl mx-auto text-center" data-id="element-225">
          <h2 className="text-2xl md:text-3xl font-black mb-8 text-brand-red" data-id="element-226">
            ⚠️ ¿Y SI NO HACÉS NADA?
          </h2>
          <div className="space-y-3 text-lg text-brand-brown-light" data-id="element-227">
            <p data-id="element-228">Más distracción. Más frustración.</p>
            <p data-id="element-229">Más dificultades escolares.</p>
            <p data-id="element-230">Más dependencia de pantallas.</p>
          </div>
          <div className="mt-8 pt-8 border-t border-brand-red/20" data-id="element-231">
            <p className="text-xl font-black text-brand-brown" data-id="element-232">
              El cerebro no entrenado se dispersa.
              <br data-id="element-233" />
              <span className="text-brand-sage" data-id="element-234">
                El cerebro entrenado mejora.
              </span>
            </p>
          </div>
        </div>
      </section>

      {/* ===== IMAGINÁ ESTO ===== */}
      <section className="py-16 px-4 bg-white" data-id="element-235">
        <div className="max-w-4xl mx-auto text-center" data-id="element-236">
          <h2 className="text-3xl md:text-5xl font-black text-brand-brown mb-10" data-id="element-237">
            🎯 IMAGINÁ ESTO
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12" data-id="element-238">
            <div className="bg-brand-sage-light p-8 rounded-2xl border border-brand-sage/20 text-left" data-id="element-239">
              <h3 className="font-black text-xl mb-4 text-brand-sage" data-id="element-240">
                En casa:
              </h3>
              <ul className="space-y-2" data-id="element-241">
                {['Más foco', 'Más autonomía', 'Más confianza'].map((item, i) => <li key={i} className="flex items-center gap-2 text-brand-brown font-medium" data-id="element-242">
                      <Check className="w-5 h-5 text-brand-sage flex-shrink-0" data-id="element-243" />
                      {item}
                    </li>)}
              </ul>
            </div>
            <div className="bg-brand-sky-light p-8 rounded-2xl border border-brand-sky/20 text-left" data-id="element-244">
              <h3 className="font-black text-xl mb-4 text-brand-sky" data-id="element-245">
                En el aula:
              </h3>
              <ul className="space-y-2" data-id="element-246">
                {['Más atención', 'Menos interrupciones', 'Mejor comprensión'].map((item, i) => <li key={i} className="flex items-center gap-2 text-brand-brown font-medium" data-id="element-247">
                    <Check className="w-5 h-5 text-brand-sky flex-shrink-0" data-id="element-248" />
                    {item}
                  </li>)}
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* ===== FINAL CTA ===== */}
      <section className="py-20 px-4 bg-brand-cream text-center" data-id="element-249">
        <div className="max-w-4xl mx-auto" data-id="element-250">
          <h2 className="text-3xl md:text-5xl font-black text-brand-brown mb-4" data-id="element-251">
            🧠 ES MOMENTO DE ENTRENAR LA MENTE
          </h2>
          <p className="text-lg text-brand-brown-light mb-2" data-id="element-252">
            Mega Pack Gimnasia Cerebral Infantil.
          </p>
          <p className="text-xl font-black text-brand-coral mb-8" data-id="element-253">
            Menos pantallas. Más cerebro activo. Más resultados reales.
          </p>

          <CTAButton subtext="Descarga inmediata · Pago único · Garantía 7 días" data-id="element-254">
            👉 EMPEZAR HOY MISMO
          </CTAButton>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-white text-brand-brown-light py-8 text-center text-sm border-t border-brand-border" data-id="element-255">
        <div className="max-w-4xl mx-auto px-4" data-id="element-256">
          <p data-id="element-257">
            © {new Date().getFullYear()} Impulso Digital. Todos los derechos
            reservados.
          </p>
          <p className="mt-2" data-id="element-258">
            Este sitio no es parte del sitio web de Facebook o Facebook Inc.
            Además, este sitio no está respaldado por Facebook de ninguna
            manera. FACEBOOK es una marca registrada de FACEBOOK, Inc.
          </p>
        </div>
      </footer>
    </div>;
}